// extracted by mini-css-extract-plugin
export default {"container":"xHd2P1fPoQqLhmINq2UJ","header":"iL_MkqkJuJyWSQq7K40r","heading":"dKxcxQ37wRtXRmdOcYWA"};